
// Define base class for account manager services
import {Utils} from "../../utils";
import {environment} from "@environments/environment";
import {Router} from "@angular/router";

export class BaseAccountManagerService {

  // Define the account manager service
  constructor(
    private _router: Router,
  ) { }

  // Go to login page
  public goToLoginPage(internal?: boolean) {

    // If internal is true, go to internal login page
    if (internal) {
      this._router.navigate(['/login']);
      return;
    }

    // Check if login page is an absolute URL or not
    if (Utils.isAbsoluteUrl(environment.loginUrl)) {
      window.location.href = environment.loginUrl;
    } else {
      this._router.navigateByUrl(environment.loginUrl);
    }

  }

}
